/*@flow*/
import gql from 'graphql-tag';

import type { DocumentNode } from 'graphql';
export default (gql(`
  query getStartupDataQuery {
    me {
      id
      company {
        id
        defaultStrokeColor
        streetscapeAssetStatuses
        streetscapeIssueStatuses
        tenantStatuses
        attractionStatuses
        eventStatuses
        buildingStatuses
        propertyStatuses
        listingStatuses
        unitStatuses
        developmentStatuses

        streetscapeAssetTypes
        streetscapeIssueCategories
        tenantCategories
        unitCategories
        listingCategories
        eventCategories
        buildingCategories
        propertyCategories
        allMarkerColors {
          type
          status
          category
          value
          visual
        }
      }
    }
  }
`): DocumentNode);
